import { Link } from "wouter";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#033644] text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-heading font-semibold mb-4 text-[#FFA500]">
              Información de Contacto
            </h3>
            <div className="space-y-3">
              <p className="flex items-center space-x-3">
                <i className="fas fa-envelope text-[#FFA500]"></i>
                <a
                  href="mailto:info@technova-eg.com"
                  className="hover:text-[#FFA500] transition-colors duration-300"
                  data-testid="link-email"
                >
                  info@technova-eg.com
                </a>
              </p>
              {/*
              <p className="flex items-center space-x-3">
                <i className="fas fa-phone text-[#FFA500]"></i>
                <a
                  href="tel:+240XXXXXXXXX"
                  className="hover:text-[#FFA500] transition-colors duration-300"
                  data-testid="link-phone"
                >
                  +240-XXX-XXX-XXX
                </a>
              </p>
               */}
              <p className="flex items-center space-x-3">
                <i className="fas fa-map-marker-alt text-[#FFA500]"></i>
                <span data-testid="text-address">Malabo, Guinea Ecuatorial</span>
              </p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-heading font-semibold mb-4 text-[#FFA500]">
              Enlaces Rápidos
            </h3>
            <ul className="space-y-2">
              <li>
                <Link 
                  href="/"
                  className="hover:text-[#FFA500] transition-colors duration-300"
                  data-testid="link-footer-home"
                >
                  Inicio
                </Link>
              </li>
              <li>
                <Link 
                  href="/services"
                  className="hover:text-[#FFA500] transition-colors duration-300"
                  data-testid="link-footer-services"
                >
                  Servicios
                </Link>
              </li>
              <li>
                <Link 
                  href="/about"
                  className="hover:text-[#FFA500] transition-colors duration-300"
                  data-testid="link-footer-about"
                >
                  Sobre Nosotros
                </Link>
              </li>
              <li>
                <Link 
                  href="/contact"
                  className="hover:text-[#FFA500] transition-colors duration-300"
                  data-testid="link-footer-contact"
                >
                  Contacto
                </Link>
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div>
            <h3 className="text-xl font-heading font-semibold mb-4 text-[#FFA500]">
              Síguenos
            </h3>
            <div className="flex space-x-4">
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#FFA500] transition-all duration-300"
                data-testid="link-twitter"
                aria-label="Twitter"
              >
                <i className="fab fa-twitter"></i>
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#FFA500] transition-all duration-300"
                data-testid="link-linkedin"
                aria-label="LinkedIn"
              >
                <i className="fab fa-linkedin-in"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-white/20 mt-8 pt-8 text-center">
          <p className="text-gray-300" data-testid="text-copyright">
            © {currentYear} Technova. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
}
